// extracted by mini-css-extract-plugin
module.exports = {"publication":"publications-module--publication--ub7In"};